import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

import {
  getCustomComponentProperty,
  styledGetCustomComponentProperty,
} from '../../../helpers';

interface $ContentProps {
  $naked: boolean;
  $isList?: boolean;
  $componentThemeName?: string;
}

const $Content = styled.div<$ContentProps>`
  padding: ${({ $naked, $isList }) => {
    if ($isList) {
      return `${spacing(3.5)} ${spacing(5)}`;
    }

    return `${spacing(3.5)} ${$naked ? 0 : spacing(3.5)}`;
  }};

  border-radius: ${({ $componentThemeName, theme }) =>
    `0 0 ${
      getCustomComponentProperty({
        theme,
        componentName: $componentThemeName,
        property: SUPPORTED_PROPERTIES.BORDER_RADIUS,
      }) || spacing(1.5)
    } ${
      getCustomComponentProperty({
        theme,
        componentName: $componentThemeName,
        property: SUPPORTED_PROPERTIES.BORDER_RADIUS,
      }) || spacing(1.5)
    }`};
  border: ${({ $componentThemeName, theme, $naked }) =>
    $naked
      ? '0px'
      : styledGetCustomComponentProperty({
          componentName: $componentThemeName,
          property: SUPPORTED_PROPERTIES.BORDER,
          fallback: `1px solid ${theme.colors.default}`,
        })};

  border-top: 0;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
`;

export default $Content;
